import s from '../styles/liens.module.css'
import OJLayout from '../components/layout'
import Head from 'next/head'
import Link from 'next/link'
import Image from 'next/image'
import * as envConstants from '../components/constants';

// Component de Liens
const LienComponent = ({itemImage, itemName, itemDescription, itemLienRedir}) => {
    return (
        
        <div className={s.partenaireDiv}>
            {/* l'image / logo du partenaire */}
            <Link href={itemLienRedir} target>
                <a className="pt-2 ml-2" target="_blank"><Image alt={itemName} src={itemImage} width={100} height={100} /></a>
            </Link>
            {/* Le nom + Description */}
            <div className={s.partenaireNomDesc}>
                <Link href={itemLienRedir}><a className="hover:text-ojblack" target="_blank">{itemName}</a></Link>
                <p>{itemDescription}</p>
            </div>  
        </div>  
    );
};

export default function Liens() {
    return (
    <OJLayout>
        <Head><title>{envConstants.SITE_NAME_OJ} - Liens</title></Head>
        <div className={s.divlien} >
            {/* Titre de la page */}
            <p className={s.title}>Liens Partenaires</p>
            {/* Grille d'affichage des partenaires grid grid-rows-3 md:grid-flow-col m-1 */}
            <div className="flex flex-wrap">
                <div className="flex flex-col m-auto">
                    <LienComponent itemName={"AMPM - Arts Martiaux Pessac Madran"} itemImage={"/logo-AMPM.png"} itemLienRedir={"https://www.ampessacmadran.club/"} 
                        itemDescription={"Gérant du Dojo de Pessac, Association pluridiciplinaire dont Open Jujitsu fait parti."} />
                    <LienComponent itemName={"EAJJ - Ecole Atemi Jujitsu"} itemImage={"/logo-EAJJ.jpg"} itemLienRedir={"http://www.atemi-jujitsu.org/"} 
                        itemDescription={"Fédération française de Jujitsu (école Pariset). Affiliation principale."} />
                    <LienComponent itemName={"FEKAMT - Fédération Européenne"} itemImage={"/logo-fekamt.jpg"} itemLienRedir={"https://www.fekamt.com/"} 
                        itemDescription={"Fédération de fédérations ayant une dimension Internationnale. L'EAJJ y est affiliée."} />
                </div>
                <div className="flex m-auto" >
                    <LienComponent itemName={"Arts et Combats - Shop"} itemImage={"/logo-arts-et-combats.png"} itemLienRedir={"https://www.artsetcombats.com/"} 
                        itemDescription={"Boxing Shop et partenaire de AMPM. Tout l'équipement et les conseils que vous avez besoin."} />
                </div>    
            </div>
        </div>
    </OJLayout>
)}